import { useState, useEffect } from 'react'

export function useClientWidth(debounceDelay = 150) {
  const [width, setWidth] = useState(null)

  useEffect(() => {
    let timeout

    const handleResize = () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        setWidth(window.innerWidth)
      }, debounceDelay)
    }

    handleResize() // set pertama kali
    window.addEventListener('resize', handleResize)

    return () => {
      clearTimeout(timeout)
      window.removeEventListener('resize', handleResize)
    }
  }, [debounceDelay])

  return width
}
